import { baseGoerliTokens } from '@pancakeswap/tokens'
import { getAddress } from 'viem'

import { PoolCategory, SerializedPool } from '../../types'

export const livePools: SerializedPool[] = [
  {
    sousId: 5,
    stakingToken: baseGoerliTokens.dackie,
    earningToken: baseGoerliTokens.quack2,
    contractAddress: '0x08c9A7e038D1BA228CCc1ADea09723459CE5EB83',
    poolCategory: PoolCategory.CORE,
    tokenPerSecond: '19',
  },
  {
    sousId: 6,
    stakingToken: baseGoerliTokens.quack2,
    earningToken: baseGoerliTokens.wbtc,
    contractAddress: '0x4e5F3eA7D1917F0A16929028282dD2A32D968Ae9',
    poolCategory: PoolCategory.CORE,
    tokenPerSecond: '0.000116',
  },
  {
    sousId: 7,
    stakingToken: baseGoerliTokens.dackie,
    earningToken: baseGoerliTokens.steth,
    contractAddress: '0x0857c0f84c6747d6a27a6f2c2b6b15487344c426',
    poolCategory: PoolCategory.CORE,
    tokenPerSecond: '0.000009',
  },
  {
    sousId: 8,
    stakingToken: baseGoerliTokens.dackie,
    earningToken: baseGoerliTokens.cbeth,
    contractAddress: '0x6638BFAA8fECBdd98bCcF79a0dBa4a8d81700431',
    poolCategory: PoolCategory.CORE,
    tokenPerSecond: '0.000009',
  },
].map((p) => ({
  ...p,
  contractAddress: getAddress(p.contractAddress, 84531),
  stakingToken: p.stakingToken.serialize,
  earningToken: p.earningToken.serialize,
}))

// known finished pools
export const finishedPools: SerializedPool[] = [
  {
    sousId: 1,
    stakingToken: baseGoerliTokens.dackie,
    earningToken: baseGoerliTokens.weth,
    contractAddress: '0x70249aF497f2040c0677f5Ea1B0dB2595f94803F',
    poolCategory: PoolCategory.CORE,
    tokenPerSecond: '0.0003858',
    isFinished: true,
  },
  {
    sousId: 2,
    stakingToken: baseGoerliTokens.dackie,
    earningToken: baseGoerliTokens.wbtc,
    contractAddress: '0xd2BC5Bd918779264aD08cfaC8A276dC6e96AF517',
    poolCategory: PoolCategory.CORE,
    tokenPerSecond: '0.0001929',
    isFinished: true,
  },
  {
    sousId: 3,
    stakingToken: baseGoerliTokens.dackie,
    earningToken: baseGoerliTokens.quack,
    contractAddress: '0x3A8bFfA7faBa5c562405b268060eD9C5062C9f2d',
    poolCategory: PoolCategory.CORE,
    tokenPerSecond: '23',
    isFinished: true,
  },
  {
    sousId: 4,
    stakingToken: baseGoerliTokens.quack,
    earningToken: baseGoerliTokens.weth,
    contractAddress: '0x28b1de7018bCe0E01c64aDe818009CC82922Aca5',
    poolCategory: PoolCategory.CORE,
    tokenPerSecond: '0.0003858',
    isFinished: true,
  },
]

export const pools: SerializedPool[] = [...livePools, ...finishedPools]
